<div *ngIf="businessname">
<div class="plans_page">
  <div class="plans_main_page">
    <div class="row plans_button">
      <div class="col-md-6" style="padding: 0px;">
        <button (click)="social()" class="plans_social"
          [ngStyle]="{'background': issocial ? 'black' : 'white', 'color': issocial ? 'white' : 'black'}">
          Social Media Plans for <span style="color: var(--primary-color);" > "{{businessname}}" </span>
        </button>
      </div>
      <div class="col-md-6" style="padding: 0px;">
        <button (click)="brand()" class="plans_brand"
          [ngStyle]="{'background': isbrand ? 'black' : 'white', 'color': isbrand ? 'white' : 'black'}">
          Branding Plans for <span style="color: var(--primary-color);" > "{{businessname}}"  </span>
        </button>
      </div>

    </div>
    <!-- social -->
    <div *ngIf="issocial">
      <div class="row">
        <div class="col-md-4">
          <div style="padding: 20px;">
            <div class="plan_subheading1">One last step and you're in!</div>
            <div class="plan_subheading2">Save Up to 50% on Annual Plans, FOREVER</div>
            <span class="plan_subheading3">SELECT PLAN</span>
            <div class="form-check form-switch plan_switch_button" style="display: flex; align-items: center;">
              <!-- Label for Monthly -->
              <label [ngClass]="{'font-weight-bold': !isMonthly}"
                style="cursor: pointer; margin-right: 10px;font-family: var(--font);font-size: 16px;">Monthly</label>

              <!-- Toggle Switch -->
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                style="height: 20px; width: 40px; cursor: pointer;margin-left: 0px;" [(ngModel)]="isMonthly"
                (change)="changesocial()">

              <!-- Label for Yearly -->
              <label [ngClass]="{'font-weight-bold': isMonthly}"
                style="cursor: pointer; margin-left: 10px;font-family: var(--font); font-size: 16px;">Quaterly</label>
            </div>
            <div class="plans_prices" *ngFor="let plan of package; let i = index">
              <div class="plan_ignite">
                <input type="radio" [(ngModel)]="selectedPlanIndex" [value]="i" (click)="plandetails(i)" name="plan"
                  style="cursor: pointer;" [checked]="i === 0">
                <div class="plan_details">
                  <div class="plan_image">
                    <img [src]="plan.image" alt="{{ plan.packagename }}" style="width: 17px; height: auto;" />
                    <div class="plan_name">{{ plan.packagename }}</div>
                  </div>
                  <div class="plan_Original_price" style="color: #b6b4b4;font-family: var(--font); font-size: 16px;">₹{{
                    plan.originalPrice }}</div>
                  <div class="plan_price" style="color: #b6b4b4;font-family: var(--font); font-size: 16px;">₹{{
                    plan.price }}</div>
                  <div class="icon_text_container" style="font-family: var(--font); font-size: 16px;"><mat-icon
                      class="material-symbols-outlined">new_releases</mat-icon>₹{{ plan.originalPrice - plan.price }} saving</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-8 plan_details">
          <div style="margin: 30px 20px 20px 20px;">

            <div class="col-md-12 plan_benefits">
              <div>
                <div class="plan_head_part">
                  <div class="plan_heading_line"></div>
                  <div class="plan_top_heading">Benefits</div>
                  <div class="plan_heading_line"></div>
                </div>
                <div *ngIf="showfeatures">
                  <ul style="font-family: var(--font);
font-size: 16px;">
                    <li *ngFor="let feature of SocialMonthlyContentofpacks[indexofplan]?.features">{{ feature }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div *ngIf="showfeatures" class="business_payment_details">
              <div class="detail_row">
                <div class="label">Selected Plan</div>
                <div class="value">(Social-Media)&nbsp;&nbsp;{{ selectedPlan }}</div>
              </div>
              <div class="detail_row">
                <div class="label">Price</div>
                <div class="value">₹{{ selectedPlanPrice }}</div>
              </div>
              <div *ngIf="AppliedCoupon" class="detail_row">
                <div class="label">Discount</div>
                <div class="value">₹{{ DiscountAmount }} - </div>
              </div>
              <div class="detail_row">
                <div class="label">GST (18%)</div>
                <div class="value">₹{{ gstAmount }}</div>
              </div>
              <div class="detail_row">
                <div class="label">Total</div>
                <div class="value">₹{{ totalAmount }}</div>
              </div>
              <div style="border:0.5px solid white ;margin: 5px 0px;"></div>
              <div (click)="openCouponDialog()" style="margin-bottom: 20px;">
                <a class="add_coupon_apply_button">Promo Benefits Code?</a>
              </div>
              <div>
                <mat-expansion-panel style="width: 100%,">
                  <mat-expansion-panel-header>
                    <mat-panel-title style="font-family: var(--font);font-size: 16px;">Have a Voucher?  </mat-panel-title>
                    <mat-panel-title *ngIf="AppliedCoupon" style="font-family: var(--font);font-size: 16px;display: flex;justify-content: flex-end;color: var(--primary-color);">Voucher Applied! </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="plans_voucher">
                    <input class="plans_voucher_code" matInput placeholder="Enter voucher code"
                      [formControl]="VoucherCode">
                    <mat-icon matSuffix class="material-symbols-outlined">
                      redeem
                    </mat-icon>
                  </mat-form-field>
                  <button class="apply_button" (click)="ApplyCoupon()">Apply</button>
                </mat-expansion-panel>
              </div>

              <div style="border:0.5px solid white ;margin-bottom: 5px;"></div>

              <div class="checkout_details">

                <button (click)="buyProduct(totalAmount,selectedPlan)" style="padding: 10px;margin: 10px 0px;border: 1px solid black;width: 100%;font-family: var(--font);border-radius : 5px;
font-size: 18px;">
                  Checkout
                  <mat-icon matSuffix class="checkout_icons_details">point_of_sale</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- branding -->
    <div *ngIf="isbrand">
      <div class="row">
        <div class="col-md-4">
          <div style="padding: 20px;">
            <div class="plan_subheading1">One last step and you're in!</div>
            <div class="plan_subheading2">Save Up to 50% on Annual Plans, FOREVER</div>
            <span class="plan_subheading3">SELECT PLAN</span>

            <div class="form-check form-switch plan_switch_button" style="display: flex; align-items: center;">
              <!-- Label for Monthly -->
              <label [ngClass]="{'font-weight-bold': !isMonthly}"
                style="cursor: pointer; margin-right: 10px;">Monthly</label>

              <!-- Toggle Switch -->
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                style="height: 20px; width: 40px; cursor: pointer;margin-left: 0px;" [(ngModel)]="isMonthly"
                (change)="changebranding()">

              <!-- Label for Yearly -->
              <label [ngClass]="{'font-weight-bold': isMonthly}"
                style="cursor: pointer; margin-left: 10px;">Quaterly</label>
            </div>
            <div class="plans_prices" *ngFor="let plan of package; let i = index">
              <div class="plan_ignite">
                <input type="radio" [(ngModel)]="selectedPlanIndex" [value]="i" (click)="plandetails(i)" name="plan"
                  style="cursor: pointer;" [checked]="i === 0">
                <div class="plan_details">
                  <div class="plan_name">{{ plan.packagename }}</div>
                  <div class="plan_Original_price">₹{{ plan.originalPrice }}</div>
                  <div class="plan_price">₹{{ plan.price }}</div>
                  <div class="icon_text_container"><mat-icon class="icons_details">new_releases</mat-icon>₹{{
                    plan.originalPrice - plan.price }} saving</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Branding Plan Benefits Section -->
        <div class="col-md-8 plan_details">
          <div style="margin: 30px 20px 20px 20px;">
            <div class="col-md-12 plan_benefits">
              <div>
                <div class="plan_head_part">
                  <div class="plan_heading_line"></div>
                  <div class="plan_top_heading">Benefits</div>
                  <div class="plan_heading_line"></div>
                </div>
                <div *ngIf="showfeatures">
                  <ul>
                    <li *ngFor="let feature of BrandingMonthlyContentofpacks[indexofplan]?.features">{{ feature }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- Payment details -->
            <div *ngIf="showfeatures" class="business_payment_details">
              <div class="detail_row">
                <div class="label">Selected Plan</div>
                <div class="value">(Branding)&nbsp;&nbsp;{{ selectedPlan }}</div>
              </div>
              <div class="detail_row">
                <div class="label">Price</div>
                <div class="value">₹{{ selectedPlanPrice }}</div>
              </div>
              <div class="detail_row">
                <div class="label">GST (18%)</div>
                <div class="value">₹{{ gstAmount }}</div>
              </div>
              <!-- Show Discount if Applied -->
              <div *ngIf="AppliedCoupon" class="detail_row">
                <div class="label">Discount</div>
                <div class="value">₹{{ DiscountAmount }} - </div>
              </div>

              <div class="detail_row">
                <div class="label">Total</div>
                <div class="value">₹{{ totalAmount }}</div>
              </div>

              <div style="border:0.5px solid white; margin: 5px 0px;"></div>

              <mat-expansion-panel *ngIf="!AppliedCoupon" style="width: 100%">
                <mat-expansion-panel-header>
                  <mat-panel-title> Have a Voucher?</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-form-field appearance="outline" class="plans_voucher">
                  <input class="plans_voucher_code" matInput placeholder="Enter voucher code"
                    [formControl]="VoucherCode">
                  <mat-icon matSuffix class="material-symbols-outlined">
                    redeem
                  </mat-icon>
                </mat-form-field>
                <button class="apply_button" (click)="ApplyCoupon()">Apply</button>
              </mat-expansion-panel>
              

              <!-- ---------Promo Code -->
              <div class="add_coupon">
                <div style="display: inline;">
                  <img src="assets\discount.png" alt="" style="height: 23px; padding-left: 20px; padding-right:8px">
                </div>
                <div (click)="toggleVoucherSection()" style="display: inline; font-size: 13px;">Apply Coupon </div>
                <div style="display: inline; text-align: right;">
                  <div class="add_coupon_apply_button">
                    Apply
                  </div>
                </div>
              </div>

              <div style="border:0.5px solid white; margin-bottom: 5px;"></div>

              <div class="checkout_details">
                <button (click)="buyProduct(totalAmount, selectedPlan)"
                  style="padding: 10px; margin: 10px 0; border: 1px solid black; width: 100%;">
                  Checkout
                  <mat-icon matSuffix class="checkout_icons_details">point_of_sale</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div *ngIf="!businessname" class="no-business-message">
  <div class="message-content">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="30" height="100">
      <path d="M21 14V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H9V20H7C6.44772 20 6 20.4477 6 21C6 21.5523 6.44772 22 7 22H17C17.5523 22 18 21.5523 18 21C18 20.4477 17.5523 20 17 20H15V18H19C20.1046 18 21 17.1046 21 16V14H21Z" fill="var(--primary-color)"/>
    </svg>
    <p class="message-text">PLEASE ADD A BUSINESS OR SELECT A BUSINESS TO DISPLAY THE PLANS</p>
    <br>
    <p class="thank-you">"THANK YOU"</p>
  </div>
</div>
